// Les différents codes d'erreur cognito sont disponible sous :
// https://docs.aws.amazon.com/fr_fr/cognito-user-identity-pools/latest/APIReference/API_Operations.html
export enum CognitoErrorsCode {
  CodeMismatchException = 'CodeMismatchException',
  ExpiredCodeException = 'ExpiredCodeException',
  LimitExceededException = 'LimitExceededException',
  UserNotFoundException = 'UserNotFoundException',
  AliasExistsException = 'AliasExistsException',
  default = 'default',
}

export enum CognitoErrorsMessage {
  CodeMismatchException = "Le code de validation n'est pas valide, veuillez réessayer.",
  ExpiredCodeException = 'Le code de validation a expiré, veuillez réessayer.',
  LimitExceededException = "Vous avez dépassé le nombre d'essais, veuillez réessayer plus tard.",
  UserNotFoundException = "L'identifiant saisie n'est pas reconnu.",
  default = 'Erreur, veuillez contacter votre adminstrateur.',
}

export const getCognitoErrorMessage = (error: string): string => {
  if (error.includes(CognitoErrorsCode.CodeMismatchException)) {
    return CognitoErrorsMessage.CodeMismatchException;
  }

  if (error.includes(CognitoErrorsCode.ExpiredCodeException)) {
    return CognitoErrorsMessage.ExpiredCodeException;
  }

  if (error.includes(CognitoErrorsCode.LimitExceededException)) {
    return CognitoErrorsMessage.LimitExceededException;
  }

  if (error.includes(CognitoErrorsCode.UserNotFoundException)) {
    return CognitoErrorsMessage.UserNotFoundException;
  }

  if (error.includes(CognitoErrorsCode.AliasExistsException)) {
    return CognitoErrorsMessage.default;
  }

  return CognitoErrorsMessage.default;
};
